import React from 'react';
import { styled } from 'linaria/react';
import Spinner from './ui/Spinner';
import { theme } from './Theme';

const LoadingPageWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vh;
  height: 100vh;
  padding: ${theme.space[3]};
`;

const LoadingPage = () => {
  return (
    <LoadingPageWrapper>
      <Spinner />
    </LoadingPageWrapper>
  );
};

export default LoadingPage;
